const styles = {
  breadcrumb: {
    margin: '16px 0'
  }
}

export default styles;



// WEBPACK FOOTER //
// ./src/components/styles/Breadcrumb.js